/*
 * @FilePath: SaleCenterConfig.js
 * @Author: lsw
 * @Date: 2023-07-25 15:57:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-30 10:07:41
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */
export default [
  {
    path: "StoreSalesOrder",
    name: "StoreSalesOrder",
    meta: {
      title: "销售单管理",
      keepAlive: true,
    },
    component: () =>
      import("@/views/Home/SalesCenter/StoreSalesOrder/index.vue"),
  },
  {
    path: "StoreSalesOrderEdit",
    name: "StoreSalesOrderEdit",
    meta: {
      title: "销售单编辑",
    },
    component: () =>
      import("@/views/Home/SalesCenter/StoreSalesOrder/edit.vue"),
  },
  {
    path: "StoreSalesOrderDetail",
    name: "StoreSalesOrderDetail",
    meta: {
      title: "销售单详情",
    },
    component: () =>
      import("@/views/Home/SalesCenter/StoreSalesOrder/detail.vue"),
  },
  {
    path: "SupervisorApplyOrder",
    name: "SupervisorApplyOrder",
    meta: {
      title: "督学申请单管理",
      keepAlive: true,
    },
    component: () =>
      import("@/views/Home/SalesCenter/SupervisorApplyOrder/index.vue"),
  },
  {
    path: "SupervisorApplyOrderEdit",
    name: "SupervisorApplyOrderEdit",
    meta: {
      title: "督学申请单编辑",
    },
    component: () =>
      import("@/views/Home/SalesCenter/SupervisorApplyOrder/edit.vue"),
  },
  {
    path: "SupervisorApplyOrderDetail",
    name: "SupervisorApplyOrderDetail",
    meta: {
      title: "督学申请单详情",
    },
    component: () =>
      import("@/views/Home/SalesCenter/SupervisorApplyOrder/detail.vue"),
  },
  {
    path: "ImportDetail/:batchNo",
    name: "ImportDetail",
    meta: {
      title: "导入详情",
    },
    component: () =>
      import("@/views/Home/SalesCenter/ExportImportQuery/ImportDetail"),
  },
  {
    path: "AgentClassImportManage",
    name: "AgentClassImportManage",
    meta: {
      title: "导入查询",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/ExportImportQuery/AgentClassImportManage"
      ),
  },
  /* 邀约大体检 */
  {
    path: "AgentAuditionDLManage",
    name: "AgentAuditionDLManage",
    meta: {
      title: "邀约大体检",
    },
    component: () =>
      import("@/views/Home/SalesCenter/InvitationManagement/InviteBigExam"),
  },
  /* 入门账号管理 */
  {
    path: "EntryAccountManagement",
    name: "EntryAccountManagement",
    meta: {
      title: "入门账号管理",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/InvitationManagement/EntryAccountManagement"
      ),
  },
  {
    path: "TrialAccountManagement",
    name: "TrialAccountManagement",
    meta: {
      title: "长期体验账号管理",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/InvitationManagement/TrialAccountManagement"
      ),
  },
  /* 钉钉潜在客户*/
  {
    path: "DingDingAgentpotentialStudentList",
    name: "DingDingAgentpotentialStudentList",
    meta: {
      title: "钉钉潜在客户",
      keepAlive: true,
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/CustomerManagement/DingDingAgentpotentialStudent"
      ),
  },
  {
    path: "ImproveScoreCase/Add",
    name: "ImproveScoreCase/Add",
    meta: {
      title: "标记为案例",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/Marketing/ImproveScoreCase/Add/index.vue"
      ),
  },
  {
    path: "ImproveScoreCase/Manage",
    name: "ImproveScoreCase/Manage",
    meta: {
      title: "案例库管理",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/Marketing/ImproveScoreCase/Manage/index.vue"
      ),
  },
  {
    path: "InstanceMigration",
    name: "InstanceMigration",
    meta: {
      title: "案例管理(校区迁移)",
    },
    component: () =>
      import("@/views/Home/SalesCenter/Marketing/InstanceMigration/index.vue"),
  },
  {
    path: "InstanceMigration/EditCaseInfo",
    name: "EditCaseInfo",
    meta: {
      title: "编辑案例",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/Marketing/InstanceMigration/editCaseInfo.vue"
      ),
  },
  {
    path: "CampusCase",
    name: "CampusCase",
    meta: {
      title: "校区案例",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/Marketing/InstanceMigration/CampusCase/index.vue"
      ),
  },
  /* 邀约管理 */
  {
    path: "AgentAuditionManage",
    name: "AgentAuditionManage",
    meta: {
      title: "邀约体验课",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/InvitationManagement/InviteExperienceClass"
      ),
  },
  /* 样机管理 */
  {
    path: "PrototypeManagement",
    name: "PrototypeManagement",
    meta: {
      title: "样机管理",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/FacilityManagement/PrototypeManagement/index.vue"
      ),
  },
  /**跨区域激活报备 */
  {
    path: "CrossAreaActivation",
    name: "CrossAreaActivation",
    meta: {
      title: "跨区域激活报备",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/FacilityManagement/CrossAreaActivation/index.vue"
      ),
  },
  {
    path: "CrossRegionalActivity",
    name: "CrossRegionalActivity",
    meta: {
      title: "跨区域活跃设备",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/FacilityManagement/CrossRegionalActivity/index.vue"
      ),
  },
  {
    path: "CrossRegionalActivityAppealRecord",
    name: "CrossRegionalActivityAppealRecord",
    meta: {
      title: "跨区域活跃设备报备审核记录",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/FacilityManagement/CrossRegionalActivityAppealRecord/index.vue"
      ),
  },
  {
    path: "CrossAreaDetails",
    name: "CrossAreaDetails",
    meta: {
      title: "跨区域激活报备详情",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/FacilityManagement/CrossAreaActivation/CrossAreaDetails.vue"
      ),
  },
  {
    path: "BackupPhoneManagement",
    name: "BackupPhoneManagement",
    meta: {
      title: "备用机管理",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/FacilityManagement/BackupPhoneManagement/index.vue"
      ),
  },
  {
    path: "CrossRegionalSales",
    name: "CrossRegionalSales",
    meta: {
      title: "学习机跨区域激活记录",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/FacilityManagement/CrossRegionalSales/index.vue"
      ),
  },
  /* 设施管理 */
  {
    path: "Counter",
    name: "Counter",
    meta: {
      title: "柜台管理",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/FacilityManagement/CounterManagement/index.vue"
      ),
  },
  {
    path: "CounterDetails",
    name: "CounterDetails",
    meta: {
      title: "柜台管理详情",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/FacilityManagement/CounterManagement/CounterDetails.vue"
      ),
  },
  {
    path: "CounterEquipment",
    name: "CounterEquipment",
    meta: {
      title: "柜台设备管理",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/FacilityManagement/CounterEquipment/index.vue"
      ),
  },
  {
    path: "DistributorEquipment",
    name: "DistributorEquipment",
    meta: {
      title: "柜台管理详情",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/DistributorManagement/DistributorEquipment/index.vue"
      ),
  },
  {
    path: "OutCall",
    name: "OutCall",
    meta: {
      title: "potentialCustomers",
      keepAlive: true,
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/CustomerManagement/PotentialCustomers/OutCall"
      ),
  },
  /* 客户管理  */
  {
    path: "ClueManagement",
    name: "ClueManagement",
    meta: {
      title: "leadManagement",
      keepAlive: true,
    },
    component: () =>
      import("@/views/Home/SalesCenter/CustomerManagement/ClueManagement"),
  },
  {
    path: "FollowUpManagement",
    name: "FollowUpManagement",
    meta: {
      title: "跟进管理",
    },
    component: () =>
      import("@/views/Home/SalesCenter/CustomerManagement/FollowUpManagement"),
  },
  {
    path: "RuleSetting",
    name: "RuleSetting",
    meta: {
      title: "规则设置",
    },
    component: () =>
      import("@/views/Home/SalesCenter/CustomerManagement/RuleSetting"),
  },
  {
    path: "AgentpotentialStudentList",
    name: "AgentpotentialStudentList",
    meta: {
      title: "potentialCustomers",
      keepAlive: true,
    },
    component: () =>
      import("@/views/Home/SalesCenter/CustomerManagement/PotentialCustomers"),
  },
  {
    path: "ChannelSourceStatistics",
    name: "ChannelSourceStatistics",
    meta: {
      title: "渠道来源统计",
      keepAlive: false,
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/CustomerManagement/ChannelSourceStatistics"
      ),
  },
  /* 共享模块 */
  {
    path: "AgentStudentDetails/:customId/:studentId?/:fromType?",
    name: "AgentStudentDetails",
    meta: {
      title: "代理学生信息",
    },
    component: () => import("@/views/Home/SalesCenter/AgentStudentDetails"),
  },
  {
    path: "AgentActivityTools",
    name: "AgentActivityTools",
    meta: {
      title: "活动工具集",
    },
    component: () =>
      import("@/views/Home/SalesCenter/Marketing/AgentActivityTools/index.vue"),
  },
  {
    path: "serviceCenterIntro",
    name: "serviceCenterIntro",
    meta: {
      title: "服务中心介绍",
    },
    component: () =>
      import("@/views/Home/SalesCenter/Marketing/serviceCenterIntro/index.vue"),
  },
  {
    path: "promotionDashboard",
    name: "promotionDashboard",
    meta: {
      title: "推广仪表盘",
    },
    component: () =>
      import("@/views/Home/SalesCenter/PromotionDashboard/index.vue"),
  },
  {
    path: "outboundCostCenter",
    name: "outboundCostCenter",
    meta: {
      title: "费用中心",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/OutboundCallSystem/CostCenter/index.vue"
      ),
  },
  {
    path: "outboundRecords",
    name: "outboundRecords",
    meta: {
      title: "外呼记录",
    },
    component: () =>
      import("@/views/Home/SalesCenter/OutboundCallSystem/Records/index.vue"),
  },
  {
    path: "examInformationManagement",
    name: "examInformationManagement",
    meta: {
      title: "考试信息",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/tandanjia/examInformationManagement/index.vue"
      ),
  },
  {
    path: "localSalesDataManagement",
    name: "localSalesDataManagement",
    meta: {
      title: "本地销售资料管理",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/tandanjia/localSalesDataManagement/index.vue"
      ),
  },
  {
    path: "CatalogManagement",
    name: "CatalogManagement",
    meta: {
      title: "资料分类目录",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/tandanjia/CatalogManagement/index.vue"
      ),
  },
  {
    path: "SchoolApplication",
    name: "SchoolApplication",
    meta: {
      title: "学校申报管理",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/tandanjia/schoolApplication/index.vue"
      ),
  },
  {
    path: "openSeaPool",
    name: "openSeaPool",
    meta: {
      title: "总部公海池",
    },
    component: () => import("@/views/Home/SalesCenter/openSeaPool/index.vue"),
  },
  {
    path: "detailSeaPoolCollection",
    name: "detailSeaPoolCollection",
    meta: {
      title: "总部公海池领取明细",
    },
    component: () =>
      import("@/views/Home/SalesCenter/detailSeaPoolCollection/index.vue"),
  },
  {
    path: "recyclingRecordSeaPool",
    name: "recyclingRecordSeaPool",
    meta: {
      title: "总部公海池回收记录",
    },
    component: () =>
      import("@/views/Home/SalesCenter/recyclingRecordSeaPool/index.vue"),
  },
  {
    path: "referralActivities",
    name: "referralActivities",
    meta: {
      title: "转介绍活动",
    },
    component: () =>
      import("@/views/Home/SalesCenter/Marketing/ReferralActivities/index.vue"),
  },
  {
    path: "/asEditor",
    name: "asEditor",
    meta: {
      title: "转介绍活动",
    },
    component: () => import("@/views/Home/AsEditor/index.vue"),
  },
  {
    path: "referralActivitiesDetail",
    name: "referralActivitiesDetail",
    meta: {
      title: "转介绍活动明细",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/Marketing/ReferralActivities/detail.vue"
      ),
  },
  {
    path: "newActivityDetail",
    name: "newActivityDetail",
    meta: {
      title: "新版转介绍活动明细",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/Marketing/ReferralActivities/newActivityDetail.vue"
      ),
  },
  {
    path: "squirrelJuvenile",
    name: "squirrelJuvenile",
    meta: {
      title: "松鼠少年",
    },
    component: () =>
      import("@/views/Home/SalesCenter/Marketing/SquirrelJuvenile/index.vue"),
  },
  {
    path: "addSquirrelJuvenile",
    name: "addSquirrelJuvenile",
    meta: {
      title: "松鼠少年推荐",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/Marketing/SquirrelJuvenile/addSquirrelJuvenile.vue"
      ),
  },
  {
    path: "TemplateList",
    name: "TemplateList",
    meta: {
      title: "模板库",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/Marketing/TemplateList/TemplateList.vue"
      ),
  },
  {
    path: "ActivityPresentManage",
    name: "ActivityPresentManage",
    meta: {
      title: "校区活动",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/Marketing/ActivityPresentManage/ActivityPresentManage.vue"
      ),
  },
  {
    path: "Participation",
    name: "Participation",
    meta: {
      title: "活动参与情况",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/Marketing/ActivityPresentManage/Participation.vue"
      ),
  },
  {
    path: "ActivityGallery",
    name: "ActivityGallery",
    meta: {
      title: "每日营销",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/Marketing/ActivityGallery/ActivityGallery.vue"
      ),
  },
  {
    path: "ReferralManage",
    name: "ReferralManage",
    meta: {
      title: "转介绍",
    },
    component: () =>
      import(
        "@/views/Home/SalesCenter/Marketing/ReferralManage/ReferralManage.vue"
      ),
  },
];
